import React from 'react';
import { Typography } from '@material-ui/core';
import classnames from 'classnames';
import styles from './ButtonFooter.styles';
import { Button } from '../Buttons';

interface ButtonFooterProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  dataTestId?: string;
  buttonText: string | GatsbyTypes.Maybe<string>;
  amount?: string | boolean;
  disabled?: boolean;
  ariaLabel?: string;
  isLoading?: boolean;
}

const ButtonFooter = ({
  onClick,
  dataTestId,
  buttonText,
  amount,
  disabled,
  ariaLabel,
  isLoading,
}: ButtonFooterProps) => {
  const classes = styles();

  const buttonWithAmount = classnames({
    [classes.buttonContainer]: amount,
  });

  return (
    <div className={classes.footer}>
      <Button
        onClick={onClick}
        data-testid={dataTestId}
        className={buttonWithAmount}
        disabled={disabled}
        aria-label={ariaLabel}
        isLoading={isLoading}
      >
        <Typography variant="h4" component="text">
          {buttonText}
        </Typography>
        {amount && (
          <Typography variant="h4" component="text">
            {amount}
          </Typography>
        )}
      </Button>
    </div>
  );
};

export default ButtonFooter;

ButtonFooter.defaultProps = {
  dataTestId: '',
  amount: false,
  disabled: false,
};
